import Repository from '../../repositories/RepositoryFactory';
const ccmAttachmentRepository = Repository.get('ccmAttachments');

export default {
	namespaced: true,
	state: {
		ccmAttachmentByPatientId: [],
		ccmAttachment: null,
		aiSummaryForCCMAttachment: null,
	},
	mutations: {
		STORE_CCM_ATTACHMENT_BY_PATIENT_ID (state, payload) {
			state.ccmAttachmentByPatientId = payload;
		},
		STORE_CCM_ATTACHMENT (state, payload) {
			state.ccmAttachment = payload;
		},
		STORE_AI_SUMMARY (state, payload) {
			state.ccmAttachment = payload;
		},
		REMOVE_CCM_ATTACHMENT (state, id) {
			state.ccmAttachmentByPatientId = state.ccmAttachmentByPatientId.filter((attachment) => attachment.id !== id);
		},
	},
	actions: {
		async getAllCCMAttachmentByPatientId ({ commit }, patientId) {
			const response = await ccmAttachmentRepository.getAllCCMAttachmentByPatientId(patientId);
			commit('STORE_CCM_ATTACHMENT_BY_PATIENT_ID', response.data);
		},

		async getSingleCCMAttachmentByPatientId ({ commit }, request) {
			const response = await ccmAttachmentRepository.getSingleCCMAttachmentByPatientId(
				request.patientId,
				request.attachmentId,
			);
			commit('STORE_CCM_ATTACHMENT', response.data);
		},

		async getCCMAttachment ({ commit }, id) {
			const response = await ccmAttachmentRepository.getCCMAttachment(id);
			return response;
		},

		async addCCMAttachment ({ commit }, body) {
			return await ccmAttachmentRepository.addCCMAttachment(body);
		},

		async deleteCCMAttachment ({ commit }, id) {
			commit('REMOVE_CCM_ATTACHMENT', id);
			return await ccmAttachmentRepository.deleteCCMAttachment(id);
		},

		async sendAttachmentToAi ({ commit }, id) {
			commit('STORE_AI_SUMMARY', await ccmAttachmentRepository.sendAttachmentToAi(id));
		},
	},
};
